'use strict';

angular.module('cgmemApp')
	.factory('Pass', ['$http', function ($http) {
		var api = {};

		api.get = (accountId, passType) => {
			let config = {params: {}};
			if(passType)
				config.params.pass_type = passType;
			
			let acct = accountId || '0';
			return $http.get(`/api/accounts/${acct}/passes`, config)
				.then(r => r.data);
		}

		api.use = (accountId, passType, qty) => {
			return $http.post(`/api/accounts/${accountId}/passes/use`, {passType, qty})
		}

		return api;
	}]);
